import { Injectable } from '@angular/core';

interface KHNativeWindow extends Window {
  webkit?: {
    messageHandlers: Record<string, {
      postMessage: (message: { Action: string; Payload?: object }) => void;
    }>;
  };
}

declare const Android: {
  postAnswerResult: (json: string) => void;
};

@Injectable({
  providedIn: 'root'
})
export class NativeAppService {
  public platform: string;

  public constructor() {
    this.platform = this.getPlatform();
  }

  private getPlatform(): string {
    const platform = localStorage.getItem('KH.Platform');

    if (platform !== 'ios' && platform !== 'android') {
      return 'Web';
    }

    return platform;
  }

  public notify(action: string, payload?: object): void {
    if (this.platform === 'ios') {
      (window as KHNativeWindow).webkit!.messageHandlers['KH.NativeCall'].postMessage({ Action: action, Payload: payload });
      return;
    }

    if (this.platform === 'android') {
      Android.postAnswerResult(JSON.stringify({ Action: action, Payload: payload }));
      return;
    }
  }

  public isNativeApp(): boolean {
    return this.platform === 'ios' || this.platform === 'android';
  }
}
